'use strict';
const angular = require('angular');

export default angular.module('conduuApp.crossFade', [])
  .directive('crossFade', function($animate, $interval, $timeout) {

    function link(scope, element, attrs){
      var intervalPromise,
        childCount,
        childPosition = 0;

      function switchToNext() {
        var prev = childPosition != 0 ? childPosition-1 : childCount-1;

        var children = element.children();
        var prevElem = angular.element(children[prev]);
        var curElem = angular.element(children[childPosition]);

        $animate.animate(prevElem, {opacity:1}, {opacity:0});
        $animate.animate(curElem, {opacity:0}, {opacity:1});

        if (++childPosition >= childCount) {
          childPosition = 0;
        }
      }

      scope.$watch(attrs.interval, function(value){
        console.log('Starting interval', value);

        if (intervalPromise) {
          $interval.cancel(intervalPromise);
        }
        intervalPromise = $interval(switchToNext, value);
      });

      scope.$watch(attrs.height, function(value){
        element.css('height', value+'%');
      });

      scope.$watch(attrs.height, function(value){
        element.css('height', value+'%');
      });

      scope.$watch(attrs.width, function(value){
        element.css('width', value+'%');
      });

      element.on('$destroy', function(){
        $interval.cancel(intervalPromise)
      });

      $timeout(_ => {

        element.addClass('cross-fade');
        element.css('display', 'block');
        element.css('position', 'relative');
        element.children()
          .addClass('cross-fade-target')
          .css('position', 'absolute')
          .css('opacity', 0);

        childCount = element.children().length;
        switchToNext();

      }, 0);
      
    }

    return {
      restrict: 'E',
      link: link
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/crossFade/crossFade.directive.js